import React from "react";
import Video from "../../main/Video";
import BackButton from "../../main/BackButton";

const MissionVideo = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/zdsb2n2mi4`}
        maxHeight="80%"
      />
    </>
  );
};

export default MissionVideo;
